import React, { useState, useEffect } from "react";
import Sidebar from "components/SideBar";
import "./index.scss";
import { Container,Row,Col } from "react-bootstrap";

const DashBoard = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [toggle, setToggle] = useState();
  const { children, templateName, sidebarStructure, selectedData,clearAllFilterArray} = props;
  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width <= 992 && !isMobile) {
      setIsMobile(true);
    } else if (width > 992 && isMobile) {
      setIsMobile(false);
    }
  };
  window.addEventListener("resize", () => checkWindowWidth());
  useEffect(() => {
    checkWindowWidth();
  }, []);

  const handleToggle = (value) =>{
    console.log(value)
    setToggle(value)
  }

  return (
      <>
          {isMobile ? (
              <>
                  <Sidebar
                      isMobile={isMobile}
                      templateName={templateName}
                      sidebarStructure={sidebarStructure}
                      selectedData={selectedData}
                      clearAllFilterArray={clearAllFilterArray}
                  />
                  <Container fluid>{children}</Container>
              </>
          ) : (
        //     <Container fluid>
        //     <Row className="p-0">
        //         <Col md={3} lg={2} className="bg-primary-theme w-lg-12 px-lg-0">
        //             <Sidebar
        //                 isMobile={isMobile}
        //                 templateName={templateName}
        //                 sidebarStructure={sidebarStructure}
        //                 selectedData={selectedData}
        //             />
        //         </Col>
        //         <Col md={9} lg={10} className="w-lg-88">
        //             {children}
        //         </Col>
        //     </Row>
        // </Container>
             <div className="">
                     <div className={`p-0 d-grid min-vh-100 delay-200 ${toggle ? 'side-bar-expanded':'side-bar-collapsed'}`}>
                      <div className="bg-white shadow">
                          <Sidebar
                              isMobile={isMobile}
                              templateName={templateName}
                              sidebarStructure={sidebarStructure}
                              selectedData={selectedData}
                              sidebarToggle={handleToggle}
                              clearAllFilterArray={clearAllFilterArray}
                          />
                      </div>
                      <div className="bg-theme-grey">
                          {children}
                      </div>
                  </div>
             </div>
                //  <div className="d-grid">
                //  <div className="bg-primary-theme ">
                //          <Sidebar
                //              isMobile={isMobile}
                //              templateName={templateName}
                //              sidebarStructure={sidebarStructure}
                //              selectedData={selectedData}
                //          />
                //      </div>
                //      <div className="">
                //          {children}
                //      </div>
                //  </div>
          )}
      </>
  );
};

export default DashBoard;
